import React, { useState, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import { Modal, Dropdown } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import Loader from '../../pages/Loader';
import axios from 'axios';
import Snackbars from '../../pages/Snackbars';
import validator from 'validator';
import { checkauhtoken } from '../../../api/PrePageLoad';
import { formatBalance } from "../../../utils";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { gtmTrackAccountTopup } from '../../../utils/gtm';
import { fbqTrackAccountTopup } from '../../../utils/meta';
import { ttqTrackAccountTopup } from '../../../utils/tiktok';

export const TopUpCard = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const [error, setError] = useState(false);
    const [error_msg, setErrorMsg] = useState("");
    const [success, setSuccess] = useState(false);
    const [success_msg, setSuccessMsg] = useState("");
    const [loader, setLoader] = useState(false);
    const [cardarray, setcardarray] = useState([]);
    const [accountarray, setaccountarray] = useState([]);

    const [select_card, setselect_card] = useState("");
    const [select_card_error, setselect_card_error] = useState("");
    const [select_account, setselect_account] = useState("");
    const [select_account_error, setselect_account_error] = useState("");
    const [select_crypto_account, setselect_crypto_account] = useState("");
    const [select_crypto_account_error, setselect_crypto_account_error] = useState("");

    const [amount, setamount] = useState("");
    const [amount_error, setamount_error] = useState("");

    const [account_balance, setaccount_balance] = useState(0);
    const [card_balance, setcard_balance] = useState(0);

    const [OTPVerification, setOTPVerification] = useState(false);
    const [otpmessage, setotpmessage] = useState("");
    const [otpmessage_error, setotpmessage_error] = useState("");
    const [transferotp, settransferotp] = useState("");

    const [GoogleAuthenticator, setGoogleAuthenticator] = useState(false);
    const [TransactionPreview, setTransactionPreview] = useState(false);
    const [authcode, setauthcode] = useState("");
    const [authcode_error, setauthcode_error] = useState("");

    const [TransferAccept, setTransferAccept] = useState(false);
    const [TransferDecline, setTransferDecline] = useState(false);
    const [success_display_from_card, setsuccess_display_from_card] = useState("");
    const [success_display_to_card, setsuccess_display_to_card] = useState("");
    const [success_display_from_account, setsuccess_display_from_account] = useState("");
    const [success_display_to_account, setsuccess_display_to_account] = useState("");
    const [success_display_refno, setsuccess_display_refno] = useState("");
    const [success_display_details, setsuccess_display_details] = useState("");
    const [currancy, setcurrancy] = useState("");

    const [error_display_details, seterror_display_details] = useState("");
    const [error_display_amount, seterror_display_amount] = useState("");

    const [minamount, setminamount] = useState("");
    const [maxamount, setmaxamount] = useState("");
    const [allcrypto, setAllcrypto] = useState([]);



    useEffect(() => {
        checkauhtoken();
        handleCryptoAcc();
        handleLoad();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

        const [holdername, setholdername] = useState("");
        const [account_number, setaccount_number] = useState("");
        const [routing_number, setrouting_number] = useState("");
        const [swiftcode, setswiftcode] = useState("");
        const [bankname, setbankname] = useState("");
        const [fundaccid, setfundaccid] = useState("");
        const [acc, setacc] = useState("");

        const handleLoadNew = (accound_id) => {
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
            }
            // setLoader(true);
            axios.get(process.env.REACT_APP_API_URL + 'account/getadminaccoundsbyid', { headers: headers })
                .then(function (res) {
                    res = res.data;
                    if (res.code === "200") {
                        if (res.data.length > 0) {

                            let currency ="USD";
                            accountarray.forEach(element => {
                                if(element.account_id_pk == accound_id){
                                    currency= element.account_currency_type;
                                }
                            });
                            res.data.forEach(element => {
                                if(element.account_currency_type == currency){
                                    setfundaccid(element.admin_account_id_pk);
                                    setholdername(element.account_name);
                                    setaccount_number(element.account_number);
                                    setrouting_number(element.routing_number);
                                    setswiftcode(element.swift_code);
                                    setbankname(element.bank_name);
                                }
                            });
                        }
                        // setTimeout(() => {
                        //     setLoader(false);
                        // }, 1000);
                    } else {
                        // setLoader(false);
                    }
                })
                .catch(function (error) {
                    setLoader(false);
                });
        }
    
        const clickclip = () => {
            setSuccess(true);
            setSuccessMsg(t("CRYPTOTRANSACTION.COPIEDMSGS"));
            setTimeout(() => {
                setSuccess(false);
            }, 6000);
        }

    const handleCryptoAcc = () => {
       
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.get(process.env.REACT_APP_API_URL + 'cryptoexchange/GetAllCryptoExchange', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setAllcrypto(res.data.usercryptowallet);
                } else {
                    setLoader(false);
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
            })
            .catch(function (error) {
                setLoader(false);
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 3000);
            });
    }

    const handleLoad = () => {

        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.get(process.env.REACT_APP_API_URL + 'cards/getusercards', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    
                    const sortedCurrencies = res.accountarray.sort((a, b) => {
                    const order = ['eur', 'usd'];
                    return order.indexOf(a.account_currency_type.toLowerCase()) - order.indexOf(b.account_currency_type.toLowerCase());
                    });
                    setaccountarray(sortedCurrencies);
                    settransferotp(res.cardtopup);
                    setLoader(false);
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const findcards = (values) => {
        let jsonpar = {
            acc_id: values
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        // setLoader(true);
        axios.post(process.env.REACT_APP_API_URL + 'cards/getusercardsByAccount', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    console.log(res.data)
                    setcardarray(res.data);
                    // setLoader(false);
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const validateCode = (value) => {
        setotpmessage(value);
        if (!validator.isEmpty(value)) {
            setotpmessage_error("");
            return true;
        } else {
            setotpmessage_error(t('FIAT.OTP_CODE_PLACE'));
            return false;
        }
    }

    const resendotp = () => {

        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        document.getElementById("submit").disabled = true;
        document.getElementById("submit").textContent = t('PROCESSING');
        axios.get(process.env.REACT_APP_API_URL + 'auth/sendandcheckotp', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setSuccess(true);
                    setSuccessMsg(res.message);
                    setTimeout(() => {
                        setSuccess(false);
                    }, 6000);
                } else {
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }

            })
            .catch(function (error) {
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const handlesubmit = () => {
        setTransactionPreview(false);
        if (validateAccount(select_account) === false) {
            setselect_account_error("Select Account");
            return false;
        } else if (validateCard(select_card) === false) {
            setselect_account_error("");
            setselect_card_error("Select Card");
            return false;
        } else if (validateAmount(amount) === false) {
            setselect_card_error("");
            setamount_error("Enter Proper Amount");
            return false;
        } else {
            setamount_error("");
            setauthcode("");
            const register_user_email = window.sessionStorage.getItem("register_user_email") || '';
            if (transferotp === "Google Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
                setGoogleAuthenticator(true);
            } else if (transferotp === "SMS OTP Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {



                const headers = {
                    'Content-Type': 'application/json',
                    'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                    'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
                }
                setLoader(true);
                axios.get(process.env.REACT_APP_API_URL + 'auth/sendandcheckotp', { headers: headers })
                    .then(function (res) {
                        res = res.data;
                        if (res.code === "200") {
                            setotpmessage("");
                            setOTPVerification(true);
                            setLoader(false);
                            setSuccess(true);
                            setSuccessMsg(res.message);
                            setTimeout(() => {
                                setSuccess(false);
                            }, 6000);
                        } else {
                            setLoader(false);
                            setError(true);
                            setErrorMsg(res.message);
                            setTimeout(() => {
                                setError(false);
                            }, 6000);
                        }

                    })
                    .catch(function (error) {
                        setLoader(false);
                        setError(true);
                        setErrorMsg(t('ERROR_MSG.SOMETHING'));
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                    });
            } else {
                finalsubmit();
            }

        }

    }

    const finalsubmit = () => {

        setauthcode_error("");
        setGoogleAuthenticator(false);
        setOTPVerification(false);
        let jsonpar = {
            select_account: select_account,
            select_card: select_card,
            amount: amount,
            authcode: authcode,
            otp: otpmessage,
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.post(process.env.REACT_APP_API_URL + 'cards/cardtopup', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    const gtmData = res?.gtmTrack;
                    if (gtmData) {
                        // Track account topup
                        gtmTrackAccountTopup({
                            card_id: gtmData?.card_id,
                            transaction_id: gtmData?.transaction_id,
                            amount: gtmData?.amount,
                            currency: gtmData?.currency,
                            account_type: gtmData?.account_type,
                            request_status: gtmData?.request_status
                        });
                        fbqTrackAccountTopup({
                            card_id: gtmData?.card_id,
                            transaction_id: gtmData?.transaction_id,
                            amount: gtmData?.amount,
                            currency: gtmData?.currency,
                            account_type: gtmData?.account_type,
                            request_status: gtmData?.request_status
                        });
                        ttqTrackAccountTopup({
                            card_id: gtmData?.card_id,
                            transaction_id: gtmData?.transaction_id,
                            amount: gtmData?.amount,
                            currency: gtmData?.currency,
                            account_type: gtmData?.account_type,
                            request_status: gtmData?.request_status
                        });
                    }

                    setsuccess_display_from_card(res.data.success_display_from_card);
                    setsuccess_display_to_card(res.data.success_display_to_card);
                    setsuccess_display_from_account(res.data.success_display_from_account);
                    setsuccess_display_to_account(res.data.success_display_to_account);
                    setsuccess_display_refno(res.data.success_display_refno);
                    setsuccess_display_details(res.data.success_display_details);
                    setcurrancy(res.data.currancy);
                    setTransferAccept(true);

                    setselect_account("");
                    setselect_card("");
                    setamount("");
                    setauthcode("");
                    setaccount_balance(0);
                    setcard_balance(0);
                    setLoader(false);
                    handleLoad();
                } else {
                    seterror_display_details(res.data.error_display_details);
                    seterror_display_amount(res.data.error_display_amount);
                    setTransferDecline(true);
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setError(true);
                setErrorMsg("Oops! Something went wrong");
                setLoader(false);
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });

    }

    const handlesubmit1 = () => {
        setTransactionPreview(false);

        const wallet = allcrypto.find(item => item.crypto_id == select_crypto_account);
        // if(wallet.wallet_address == null) {
        //     setError(true);
        //     setErrorMsg("Please generate your crypto wallet to proceed.");
        //     setTimeout(() => {
        //         setError(false);
        //     }, 6000);
        //     return false;
        // }

        if (validateCrypto(select_crypto_account) === false) {
            setselect_crypto_account_error("Select Crypto");
            return false;
        }else if (validateAmount(amount) === false) {
            setselect_crypto_account_error("")
            setamount_error("Enter Proper Amount");
            return false;
        }else if (validateAccount(select_account) === false) {
            setamount_error("");
            setselect_account_error("Select Fiat");
            return false;
        } else if (validateCard(select_card) === false) {
            setselect_account_error("");
            setselect_card_error("Select Card");
            return false;
        }else {
            setselect_card_error("");
            setauthcode("");
            const register_user_email = window.sessionStorage.getItem("register_user_email") || '';
            if (transferotp === "Google Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
                setGoogleAuthenticator(true);
            } else if (transferotp === "SMS OTP Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {

                const headers = {
                    'Content-Type': 'application/json',
                    'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                    'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
                }
                setLoader(true);
                axios.get(process.env.REACT_APP_API_URL + 'auth/sendandcheckotp', { headers: headers })
                    .then(function (res) {
                        res = res.data;
                        if (res.code === "200") {
                            setotpmessage("");
                            setOTPVerification(true);
                            setLoader(false);
                            setSuccess(true);
                            setSuccessMsg(res.message);
                            setTimeout(() => {
                                setSuccess(false);
                            }, 6000);
                        } else {
                            setLoader(false);
                            setError(true);
                            setErrorMsg(res.message);
                            setTimeout(() => {
                                setError(false);
                            }, 6000);
                        }

                    })
                    .catch(function (error) {
                        setLoader(false);
                        setError(true);
                        setErrorMsg(t('ERROR_MSG.SOMETHING'));
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                    });
            } else {
                finalsubmit1();
            }

        }

    }

    const finalsubmit1 = () => {

        setauthcode_error("");
        setGoogleAuthenticator(false);
        setOTPVerification(false);
        let jsonpar = {
            select_crypto_account: select_crypto_account,
            select_account: select_account,
            select_card: select_card,
            amount: amount,
            authcode: authcode,
            otp: otpmessage,
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.post(process.env.REACT_APP_API_URL + 'cards/cardtopupbycrypto', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    const gtmData = res?.gtmTrack;
                    if (gtmData) {
                        // Track account topup
                        gtmTrackAccountTopup({
                            card_id: gtmData?.card_id,
                            transaction_id: gtmData?.transaction_id,
                            amount: gtmData?.amount,
                            currency: gtmData?.currency,
                            account_type: gtmData?.account_type,
                            request_status: gtmData?.request_status
                        });
                        ttqTrackAccountTopup({
                            card_id: gtmData?.card_id,
                            transaction_id: gtmData?.transaction_id,
                            amount: gtmData?.amount,
                            currency: gtmData?.currency,
                            account_type: gtmData?.account_type,
                            request_status: gtmData?.request_status
                        });
                    }

                    setsuccess_display_from_card(res.data.success_display_from_card);
                    setsuccess_display_to_card(res.data.success_display_to_card);
                    setsuccess_display_from_account(res.data.success_display_from_account);
                    setsuccess_display_to_account(res.data.success_display_to_account);
                    setsuccess_display_refno(res.data.success_display_refno);
                    setsuccess_display_details(res.data.success_display_details);
                    setcurrancy(res.data.currancy);
                    setTransferAccept(true);

                    setselect_account("");
                    setselect_card("");
                    setamount("");
                    setauthcode("");
                    setaccount_balance(0);
                    setcard_balance(0);
                    setLoader(false);
                    handleLoad();
                } else {
                    seterror_display_details(res.data.error_display_details);
                    seterror_display_amount(res.data.error_display_amount);
                    setTransferDecline(true);
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setError(true);
                setErrorMsg("Oops! Something went wrong");
                setLoader(false);
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });

    }

    const getlimit = (value) => {
        let jsonpar = {
            coinname: value,
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        // setLoader(true);
        axios.post(process.env.REACT_APP_API_URL + 'limits/getbaselimit', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setminamount(res.mincardtopup);
                    setmaxamount(res.maxcardtopup);
                    // setTimeout(() => {
                    //     setLoader(false);
                    // }, 1000);
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const validateAuthcode = (value) => {
        setauthcode(value);
        if (!validator.isEmpty(value)) {
            setauthcode_error("");
            return true;
        } else {
            setauthcode_error("Enter 6 digit google authetication code");
            return false;
        }
    }

    const validateAccount = (value) => {
        handleLoadNew(value)
        setselect_account(value);
        setselect_card("");
        if (!validator.isEmpty(value)) {
            setselect_account_error("");

            let symbole = "$";
            for (let i = 0; i < accountarray.length; i++) {
                if (accountarray[i].account_id_pk === value) {
                    setacc(accountarray[i].account_currency_type)
                    if (accountarray[i].account_currency_type === "EUR") {
                        symbole = "€";
                        getlimit(accountarray[i].account_currency_type);
                    } else {
                        getlimit(accountarray[i].account_currency_type);
                    }
                    setaccount_balance(symbole + accountarray[i].available_balance);
                }
            }
            findcards(value);
            return true;
        } else {
            setselect_account_error("Select your account");
            return false;
        }
    }

    const validateCard = (value) => {
        setselect_card(value);
        if (!validator.isEmpty(value)) {
            setselect_card_error("");
            let symbole = "$";
            for (let i = 0; i < cardarray.length; i++) {
                if (cardarray[i].card_id === value) {
                    if (cardarray[i].card_currancy === "EUR") {
                        symbole = "€";
                    }
                    setcard_balance(symbole + cardarray[i].card_balance);
                }
            }
            return true;
        } else {
            setselect_card_error("Select your card");
            return false;
        }
    }

    const validateAmount = (value) => {
        setamount(value);
        if (validator.isNumeric(value) && parseFloat(value) > 0) {
            if (parseFloat(maxamount) > 0) {
                if (parseFloat(value) < parseFloat(minamount)) {
                    setamount_error(`Minimum Amount is ${minamount} ${acc?acc:""}`);
                    return false;
                }

                if (parseFloat(value) > parseFloat(maxamount)) {
                    setamount_error(`Maximum Amount is ${maxamount} ${acc?acc:""}`);
                    return false;
                }
            }
            setamount_error("");
            return true;
        } else {
            setamount_error("Enter amount");
            return false;
        }
    }

    const [activeToggle, setActiveToggle] = useState("fiat");
        const validateCrypto = (value) => {
            setselect_crypto_account(value);
            if (!validator.isEmpty(value)) {
                setselect_crypto_account_error("");
                return true;
            } else {
                setselect_crypto_account_error("Select Crypto Account");
                return false;
            }
        }


        const [success_display_topup_currency, setsuccess_display_topup_currency] = useState("");
        const [success_display_topup_amount, setsuccess_display_topup_amount] = useState("");
        const [success_display_debit_amount, setsuccess_display_debit_amount] = useState("");
        const [success_display_fee_amount, setsuccess_display_fee_amount] = useState("");
        const [exchangerateprice, setexchangerateprice] = useState("");
        

        const handleTransactionPreview = () => {
            if (validateAccount(select_account) === false) {
                setselect_account_error("Select Account");
                return false;
            } else if (validateCard(select_card) === false) {
                setselect_account_error("");
                setselect_card_error("Select Card");
                return false;
            } else if (validateAmount(amount) === false) {
                setselect_card_error("");
                setamount_error("Enter Proper Amount");
                return false;
            } else {
                setamount_error("");
                setLoader(true);
    
                let jsonpar = {
                    select_account: select_account,
                    select_card: select_card,
                    amount: amount,
                }
                const headers = {
                    'Content-Type': 'application/json',
                    'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                    'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
                }
                axios.post(process.env.REACT_APP_API_URL + 'cards/cardtopupcheck', jsonpar, { headers: headers })
                    .then(function (res) {
                        res = res.data;
                        if (res.code === "200") {
                            setLoader(true);
                            setTransactionPreview(true);                
                            setsuccess_display_topup_currency(res.data.success_display_topup_currency);
                            setsuccess_display_topup_amount(res.data.success_display_topup_amount);
                            setsuccess_display_debit_amount(res.data.success_display_debit_amount);
                            setsuccess_display_fee_amount(res.data.success_display_fee_amount);        
                            setLoader(false);
                        } else {
                            seterror_display_details(res.data.error_display_details);
                            seterror_display_amount(res.data.error_display_amount);
                            setTransferDecline(true);
                            setLoader(false);
                        }
                    })
                    .catch(function (error) {
                        setError(true);
                        setErrorMsg("Oops! Something went wrong");
                        setLoader(false);
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                    });
        
                }
        }

        const handleTransactionPreview1 = () => {
            if (validateCrypto(select_crypto_account) === false) {
                setselect_crypto_account_error("Select Crypto");
                return false;
            }else if (validateAmount(amount) === false) {
                setselect_crypto_account_error("")
                setamount_error("Enter Proper Amount");
                return false;
            }else if (validateAccount(select_account) === false) {
                setamount_error("");
                setselect_account_error("Select Fiat");
                return false;
            } else if (validateCard(select_card) === false) {
                setselect_account_error("");
                setselect_card_error("Select Card");
                return false;
            }else {
                setselect_card_error("");
                setLoader(true);
            let jsonpar = {
                select_crypto_account: select_crypto_account,
                select_account: select_account,
                select_card: select_card,
                amount: amount,
            }
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
            }
            axios.post(process.env.REACT_APP_API_URL + 'cards/cardtopupbycryptocheck', jsonpar, { headers: headers })
                .then(function (res) {
                    res = res.data;
                    if (res.code === "200") {
                        setTransactionPreview(true);
                        setsuccess_display_topup_currency(res.data.success_display_topup_currency);
                        setsuccess_display_topup_amount(res.data.success_display_topup_amount);
                        setsuccess_display_debit_amount(res.data.success_display_debit_amount);
                        setsuccess_display_fee_amount(res.data.success_display_fee_amount);  
                        setexchangerateprice(res.data.exchangerateprice);    
  
                        setLoader(false);
                    } else {
                        seterror_display_details(res.data.error_display_details);
                        seterror_display_amount(res.data.error_display_amount);
                        setTransferDecline(true);
                        setLoader(false);
                    }
                })
                .catch(function (error) {
                    setError(true);
                    setErrorMsg("Oops! Something went wrong");
                    setLoader(false);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                });
    
            }
    }

    const ActiveToggle = () => {
        setActiveToggle("fiat");
        setselect_account("");
        setselect_card("");
        setamount("");
        setauthcode("");
        setaccount_balance(0);
        setcard_balance(0);
        setacc("");
        setminamount("");
        setmaxamount("");
    }

    const ActiveToggle1 = () => {
        setActiveToggle("crypto");
        setselect_account("");
        setselect_card("");
        setamount("");
        setauthcode("");
        setaccount_balance(0);
        setcard_balance(0);
        setacc("");
        setminamount("");
        setmaxamount("");
    }

    const formatCardNumber = (number) => {
        if (!number) return '';
        return number
        .toString()
        .replace(/\s+/g, '')
        .match(/.{1,4}/g)
        ?.join(' ') || '';
    };

    return (
        <>
            {error ? <Snackbars open_close={error} type="error" message={error_msg} /> : ""}
            {success ? <Snackbars open_close={success} type="success" message={success_msg} /> : ""}
            {/* <p> We're actively upgrading our platform. If you face any issues, please be assured our team is addressing them promptly.</p> */}
            <div className="form-head mb-4">
                <h2 className="text-black font-w500 mb-0">Top Up Card</h2>
            </div>
            <ul className="nav nav-tabs crypto-tabs-btn">
                <li className="nav-item" onClick={ActiveToggle}>
                    <Link to="#01" data-toggle="tab" className={`nav-link ${activeToggle === "fiat" ? "active show" : ""}`}>Fiat Top Up</Link>
                </li>
                <li className="nav-item" onClick={ActiveToggle1}>
                    <Link to="#02" data-toggle="tab" className={`nav-link ${activeToggle === "crypto" ? "active show" : ""}`}>Crypto Top Up</Link>
                </li>
            </ul>
            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <div className="card card-form tab-content">
                   <div id="01" className={`tab-pane fade ${activeToggle === "fiat" ? "active show" : ""}`} >

                    <div className="card-body payment-bx tab-content p-4 recent-Transactions-bottom">
                        <div className="row">
                            <div className="col-md-6">
                                <div className='form-group mb-2 fullWidth'>
                                    <label className='mb-1 fullWidth'>Select Fiat</label>
                                    <div className="form-group position-relative">
                                        <select className="form-control webkit-none" onChange={(e) => validateAccount(e.target.value)} value={select_account}>
                                            <option value="">Select Fiat</option>
                                            {accountarray && accountarray.map((row) => (
                                                <option value={row.account_id_pk} key={row.account_id_pk}>{row.account_currency_type} {formatBalance(row.account_balance)}</option>
                                            ))}
                                        </select>
                                        <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                    </div>
                                    {select_account_error !== "" ? <label className='text-red'>{select_account_error}</label> : ""}
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className='form-group mb-2 fullWidth'>
                                    <label className='mb-1 fullWidth'>Select Card</label>
                                    <div className="form-group position-relative">
                                        <select className="form-control webkit-none" onChange={(e) => validateCard(e.target.value)} value={select_card}>
                                            <option value="">Select Card</option>
                                            {cardarray && cardarray.map((row) => (
                                                <option value={row.card_id} key={row.card_id}>{formatCardNumber(row.card_number)} ( {row.card_name} )</option>
                                            ))}
                                        </select>
                                        <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                    </div>
                                    {select_card_error !== "" ? <label className='text-red'>{select_card_error}</label> : ""}
                                </div>
                            </div>
                        </div>

                        {/* <div className="row mb-2 mb-2 mt-2">
                            <div className="col-md-9 col-12">
                                <h5 className="f-w-500">Account Balance<span className="pull-end"> :</span>
                                </h5>
                            </div>
                            <div className="col-md-3 col-12 text-right text-left-mobile"><span>{account_balance}</span>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-md-9 col-12">
                                <h5 className="f-w-500">Prepaid Card Balance<span className="pull-end"> :</span>
                                </h5>
                            </div>
                            <div className="col-md-3 col-12 text-right text-left-mobile"><span>{card_balance}</span>
                            </div>
                        </div> */}

                        <div className="row">

                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="mb-2">{acc?acc:"Fiat"} Amount</label>
                                            <input type="number" className="form-control" placeholder={acc ? "Please enter "+acc+" amount" : "Please enter fiat amount"} onChange={(e) => validateAmount(e.target.value)} value={amount} />
                                            {amount_error !== "" ? <label className='text-red'>{amount_error}</label> : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {parseFloat(minamount) > 0 ?
                                <div className="col-md-12 mt-1">
                                    <label className="mb-2 minmaxclass"><span>Minimum TopUp Amount = {minamount} {acc?acc:""}</span></label>
                                    <label className="mb-2 ml-3 minmaxclass"><span>Maximum TopUp Amount = {maxamount} {acc?acc:""}</span></label>
                                </div>
                                : ""}

                            <div className="col-md-12 mt-4">
                                <Link to="#" onClick={handleTransactionPreview} className="btn btn-primary btn-rounded">Continue</Link>
                                <Link to="/my-cards" className="btn btn-outline-light ml-3 btn-rounded">Cancel</Link>
                            </div>
                        </div>

                    </div>
                    </div>

                    <div id="02" className={`tab-pane fade ${activeToggle === "crypto" ? "active show" : ""}`} >
                    <div className="card-body payment-bx tab-content p-4 recent-Transactions-bottom">
                        <div className="row">

                            <div className="col-md-6">
                                <div className='form-group mb-2 fullWidth'>
                                    <label className='mb-1 fullWidth'>Select Crypto</label>
                                    <div className="form-group position-relative">
                                        <select className="form-control webkit-none" onChange={(e) => validateCrypto(e.target.value)} value={select_crypto_account}>
                                            <option value="">Select Crypto</option>
                                            {allcrypto && allcrypto.map((row) => (
                                                            <option value={row.crypto_id} key={row.crypto_wallet_id}>{row.coin_code} {row.coin_code =="USDC"? "(ERC 20)": ""} { "(" + row.total_available  + ")"}</option>
                                            ))}
                                        </select>
                                        <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                    </div>
                                    {select_crypto_account_error !== "" ? <label className='text-red'>{select_crypto_account_error}</label> : ""}
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className='form-group mb-2 fullWidth'>
                                    <label className='mb-1 fullWidth'>Select Fiat</label>
                                    <div className="form-group position-relative">
                                        <select className="form-control webkit-none" onChange={(e) => validateAccount(e.target.value)} value={select_account}>
                                            <option value="">Select Fiat</option>
                                            {accountarray && accountarray.map((row) => (
                                                <option value={row.account_id_pk} key={row.account_id_pk}>{row.account_currency_type} </option>
                                            ))}
                                        </select>
                                        <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                    </div>
                                    {select_account_error !== "" ? <label className='text-red'>{select_account_error}</label> : ""}
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="form-group mb-2 fullWidth">
                                        <div className="form-group position-relative">
                                            <label className="mb-1 fullWidth">{acc?acc:"Fiat"} Amount</label>
                                            <input type="number" className="form-control" placeholder={acc ? "Please enter "+acc+" amount" : "Please enter fiat amount"} onChange={(e) => validateAmount(e.target.value)} value={amount} />
                                            {amount_error !== "" ? <label className='text-red'>{amount_error}</label> : ""}
                                        </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className='form-group mb-2 fullWidth'>
                                    <label className='mb-1 fullWidth'>Select Card</label>
                                    <div className="form-group position-relative">
                                        <select className="form-control webkit-none" onChange={(e) => validateCard(e.target.value)} value={select_card}>
                                            <option value="">Select Card</option>
                                            {cardarray && cardarray.map((row) => (
                                                <option value={row.card_id} key={row.card_id}>{formatCardNumber(row.card_number)} ( {row.cardtypename} )</option>
                                            ))}
                                        </select>
                                        <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                    </div>
                                    {select_card_error !== "" ? <label className='text-red'>{select_card_error}</label> : ""}
                                </div>
                            </div>

                        </div>



                        <div className="row">
                            {parseFloat(minamount) > 0 ?
                                <div className="col-md-12 mt-4">
                                    <label className="mb-2 minmaxclass"><span>Minimum TopUp Amount = {minamount} {acc?acc:""}</span></label>
                                    <label className="mb-2 ml-3 minmaxclass"><span>Maximum TopUp Amount = {maxamount} {acc?acc:""}</span></label>
                                </div>
                                : ""}
                            <div className="col-md-12 mt-4">
                                    {activeToggle=="fiat"?
                                    <Link to="#" onClick={handleTransactionPreview} className="btn btn-primary btn-rounded">Continue</Link>
                                    :
                                    <Link to="#" onClick={handleTransactionPreview1} className="btn btn-primary btn-rounded">Continue</Link>
                                    }
                                <Link to="/my-cards" className="btn btn-outline-light ml-3 btn-rounded">Cancel</Link>
                            </div>
                        </div>

                    </div>
                    </div>
                    <Modal className="modal fade" show={OTPVerification}>
                        <div className="modal-dialog-centered " >
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h3 className="modal-title">{t('FIAT.OTPVERIFICATION_TITLE')}</h3>
                                    <button type="button" className="close" onClick={() => setOTPVerification(false)}><span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="mb-2 ">{t('FIAT.OTP_CODE_TITLE')}</label>
                                                <input type="text" minLength={6} maxLength={6} onChange={(e) => validateCode(e.target.value)} value={otpmessage} className="form-control" placeholder={t('FIAT.OTP_CODE_PLACE')} />
                                                <p className="resendcode"><Link to="#" onClick={resendotp}>{t('FIAT.RESEND_OTP')}</Link></p>
                                                <label className="mb-2 ">{"Verification code has been sent to your registered mobile number"}</label>
                                            </div>
                                            {otpmessage_error !== "" ? <label className='text-red'>{otpmessage_error}</label> : ""}
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-light btn-rounded light" onClick={() => setOTPVerification(false)}>{t('BUTTONS.CANCEL')}</button>
                                    {activeToggle=="fiat"?
                                    <button type="button" onClick={finalsubmit} className="btn btn-primary btn-rounded">{t('BUTTONS.SUBMIT')}</button>
                                    :
                                    <button type="button" onClick={finalsubmit1} className="btn btn-primary btn-rounded">{t('BUTTONS.SUBMIT')}</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal className="modal fade" show={GoogleAuthenticator}>
                        <div className="modal-dialog-centered " >
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h3 className="modal-title">Google Authenticator</h3>
                                    <button type="button" className="close" onClick={() => setGoogleAuthenticator(false)}><span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="mb-2 ">Google Authenticator Code</label>
                                                <input type="text" maxLength="6" className="form-control text-black" placeholder="Please Enter Google Authenticator Code" onChange={(e) => validateAuthcode(e.target.value)} value={authcode} />
                                                {authcode_error !== "" ? <label className='text-red'>{authcode_error}</label> : ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-light btn-rounded light" onClick={() => setGoogleAuthenticator(false)}>Close</button>
                                    {activeToggle=="fiat"?
                                    <Link to="#" onClick={finalsubmit} className="btn btn-primary btn-rounded">Submit</Link>
                                    :
                                    <Link to="#" onClick={finalsubmit1} className="btn btn-primary btn-rounded">Submit</Link>
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal className="modal fade" show={TransferAccept}>
                        <div className="modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h3 className="modal-title">Card Topup Request</h3>
                                    <button type="button" className="close" onClick={() => setTransferAccept(false)}><span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    
                                    {success_display_refno === "" || success_display_refno === undefined || success_display_refno === null ? 
                                        <>
                                        <div className="check">
                                            <i class="fa fa-solid fa-check"></i>
                                            <p className="fs-14 mb-1 Submitted">Topup Transaction Request Submitted</p>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12 mb-1">
                                                <p className="fs-16 mb-1">We have received your request and our team will review it shortly. You will be notified once the request has been processed.</p>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12 mb-1">
                                                <p className="fs-16 mb-1">Topup Amount to Card : <span className="text-black">{success_display_from_card}</span></p>
                                            </div>
                                        </div>
          
                                        
                                        <div className="row">
                                        {activeToggle=="fiat"?
                                            <div className="col-md-12 mb-1">
                                                <p className="fs-16 mb-1">Debited  Amount From {currancy} Account : <span className="text-black">{success_display_to_card}</span></p>
                                            </div>
                                        :
                                            <div className="col-md-12 mb-1">
                                                <p className="fs-16 mb-1">Debited  Amount From Crypto Account : <span className="text-black">{success_display_to_card}</span></p>
                                            </div>
                                        }
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 mb-1">
                                                <p className="fs-16 mb-1">Topup Card Number : <span className="text-black">{success_display_from_account}</span></p>
                                            </div>
                                        </div>
                                        <div className="row">
                                        {activeToggle=="fiat"?
                                            <div className="col-md-12 mb-1">
                                                <p className="fs-16 mb-1">Debited {currancy} Account Number : <span className="text-black">{success_display_to_account}</span></p>
                                            </div>
                                            :
                                            <div className="col-md-12 mb-1">
                                                <p className="fs-16 mb-1">Debited Crypto Wallet Address : <span className="text-black">{success_display_to_account}</span></p>
                                            </div>
                                        }
                                        </div>
                                        </>
                                    :
                                        <>
                                            <div className="check">
                                                <i class="fa fa-solid fa-check"></i>
                                                <p className="fs-14 mb-1 Submitted">Topup Transaction Successfull</p>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 mb-1">
                                                    <p className="fs-16 mb-1">Topup Amount to Card : <span className="text-black">{success_display_from_card}</span></p>
                                                </div>
                                            </div>
                                            <div className="row">
                                            {activeToggle=="fiat"?
                                                <div className="col-md-12 mb-1">
                                                    <p className="fs-16 mb-1">Debited  Amount From {currancy} Account : <span className="text-black">{success_display_to_card}</span></p>
                                                </div>
                                            :
                                                <div className="col-md-12 mb-1">
                                                    <p className="fs-16 mb-1">Debited  Amount From Crypto Account : <span className="text-black">{success_display_to_card}</span></p>
                                                </div>
                                            }
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 mb-1">
                                                    <p className="fs-16 mb-1">Topup Card Number : <span className="text-black">{success_display_from_account}</span></p>
                                                </div>
                                            </div>
                                            <div className="row">
                                            {activeToggle=="fiat"?
                                                <div className="col-md-12 mb-1">
                                                    <p className="fs-16 mb-1">Debited {currancy} Account Number : <span className="text-black">{success_display_to_account}</span></p>
                                                </div>
                                                :
                                                <div className="col-md-12 mb-1">
                                                    <p className="fs-16 mb-1">Debited Crypto Wallet Address : <span className="text-black">{success_display_to_account}</span></p>
                                                </div>
                                            }
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mb-1">
                                                    <p className="fs-16 mb-1">Reference Number : <span className="text-black">{success_display_refno}</span></p>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {/* <div className="row mt-1">
                                        <div className="col-md-12 mb-3">
                                            <p className="fs-16 mb-1">Details</p>
                                            <span className="text-black">{success_display_details}</span>
                                        </div>
                                    </div> */}
                                    <div className="row mt-3 mb-2">
                                        <ul className="btm-link">
                                            <li>
                                                <Link to="#" onClick={() => setTransferAccept(false)}>New Card Topup</Link>
                                            </li>
                                            <li>
                                                <Link to="/dashboard"> Dashboard</Link>
                                            </li>
                                            <li>
                                                <Link to="/top-up-transactions"> Transaction List</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal className="modal fade" show={TransferDecline}>
                        <div className="modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h3 className="modal-title">Card Topup</h3>
                                    <button type="button" className="close" onClick={() => setTransferDecline(false)}><span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="check">
                                        <i class="fa fa-solid fa-times"></i>
                                        <p className="fs-14 mb-1 Submitted">Transaction Failed</p>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">Amount : <span className="text-black">{error_display_amount}</span></p>
                                        </div>
                                    </div>

                                    <div className="row mt-1">
                                        <div className="col-md-12 mb-3">
                                            <p className="fs-16 mb-1">Details</p>
                                            <span className="text-black">{error_display_details}</span>
                                        </div>
                                    </div>
                                    <div className="row mt-3 mb-2">
                                        <ul className="btm-link">
                                            <li>
                                                <Link to="#" onClick={() => setTransferDecline(false)}> Retry </Link>
                                            </li>
                                            <li>
                                                <Link to="/dashboard"> Dashboard</Link>
                                            </li>
                                            <li>
                                                <Link to="/top-up-transactions"> Transaction List</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal className="modal fade" show={TransactionPreview}>
                        <div className="modal-dialog-centered" >
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h3 className="modal-title">Transaction Details</h3>
                                    <button type="button" className="close" onClick={() => setTransactionPreview(false)}><span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">Order Amount : <span className="text-black">{success_display_debit_amount}</span></p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">Site Fee : <span className="text-black">{success_display_fee_amount}</span></p>
                                        </div>
                                    </div>

                                    {activeToggle=="crypto"?
                                    <div className="row">
                                    <div className="col-md-12 mb-1">
                                        <p className="fs-16 mb-1">Exchange Rate : <span className="text-black">{exchangerateprice}</span></p>
                                    </div>
                                    </div>
                                    :""
                                    }

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">TopUp Amount : <span className="text-black">{success_display_topup_amount}</span></p>
                                        </div>
                                    </div>


                                    <div className="mt-4 flex-wrap border-0 pb-0 align-items-end">
                                        <Dropdown className="mb-auto">
                                            <Dropdown.Toggle variant="" as="div" className="btn-link i-false share-info" >
                                                <i className="fa fa-share-alt-square" aria-hidden="true" style={{ marginRight: '13px' }}></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                                                <CopyToClipboard text={
                                                    t("FIAT.FIAT_DEPOSIT_LABEL1") + " : " + holdername + "\n" +

                                                    t("FIAT.FIAT_DEPOSIT_LABEL2") + " : " + account_number + "\n" +

                                                    t("FIAT.FIAT_DEPOSIT_LABEL3") + " : " + routing_number + "\n" +

                                                    t("FIAT.FIAT_DEPOSIT_LABEL4") + " : " + swiftcode + "\n" +

                                                    t("FIAT.FIAT_DEPOSIT_LABEL5") + " : " + bankname + "\n" 
                                                    }>
                                                    <Dropdown.Item onClick={clickclip}>{t('HEADER.CLIPBOARD')}</Dropdown.Item>
                                                </CopyToClipboard>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <div className="accordion-body-text mt-2" id="capture">
                                            <p className="instructions">Admin account details:</p>
                                            <p className="instructions-details">{t('FIAT.FIAT_DEPOSIT_LABEL1')}: {holdername}</p>
                                            <p className="instructions-details">{t('FIAT.FIAT_DEPOSIT_LABEL2')}: {account_number}</p>
                                            <p className="instructions-details">{t('FIAT.FIAT_DEPOSIT_LABEL3')}: {routing_number}</p>
                                            <p className="instructions-details">{t('FIAT.FIAT_DEPOSIT_LABEL4')}: {swiftcode}</p>
                                            <p className="instructions-details">{t('FIAT.FIAT_DEPOSIT_LABEL5')}: {bankname}</p>
                                            {/* <p className="instructions-details-btm mt-2">{t('FIAT.INCOMMING_NOTE_TWO')}</p> */}
                                        </div>
                                    </div>
                                </div>                           

                                <div className="modal-footer">
                                    <button className="btn btn-light btn-rounded light" onClick={() => setTransactionPreview(false)}>Close</button>
                                    {activeToggle=="fiat"?
                                    <Link to="#" onClick={handlesubmit} className="btn btn-primary btn-rounded">Submit</Link>
                                    :
                                    <Link to="#" onClick={handlesubmit1} className="btn btn-primary btn-rounded">Submit</Link>
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            }
        </>
    )

}
export default TopUpCard;